module.exports = __webpack_public_path__ + "static/img/2.5f6ca4ea.jpeg";